import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { IWorkItOutData, PayCycleOptions, Bank } from 'types';
import { actionSaveStepWorkItOut } from 'store/modules/sign-up/actions';
import { IReducerState, history } from 'store/main-reducer';
import { getWorkItOutData } from 'store/modules/sign-up/selectors';

import {
  getBankOptions, getManageHrOptions, getManagePayCycleOptions, getHasLoadedOptions, getPayCycleOptions,
} from 'store/modules/options/selectors';
import { CallbackRequestModal } from 'views/components/CallbackRequestModal/CallbackRequestModal';
import { WorkItOutView } from './WorkItOut';

interface Props {
  intl: IntlShape;
  initialData: IWorkItOutData;
  saveStepWorkItOut: typeof actionSaveStepWorkItOut;
  bankOptions: Bank[];
  manageHrOptions: string[];
  managePayCycleOptions: PayCycleOptions[];
  hasLoadedOptions: boolean;
  payCycles: string[];
}

const WorkItOutController = (props: Props) => {
  const {
    intl,
    initialData,
    saveStepWorkItOut,
    bankOptions,
    manageHrOptions,
    managePayCycleOptions,
    hasLoadedOptions,
    payCycles,
  } = props;

  const goToNextStep = () => {
    history.push('/sign-up/pick-a-plan');
  };

  if (!hasLoadedOptions) {
    history.push('/');
  }

  return (
    <>
      <WorkItOutView
        intl={intl}
        bankOptions={bankOptions}
        manageHrOptions={manageHrOptions}
        managePayCycleOptions={managePayCycleOptions}
        initialData={initialData}
        saveStepWorkItOut={saveStepWorkItOut}
        goToNextStep={goToNextStep}
        payCycles={payCycles}
      />
      <CallbackRequestModal />
    </>
  );
};

const mapStateToProps = (state: IReducerState) => ({
  initialData: getWorkItOutData(state),
  bankOptions: getBankOptions(state),
  manageHrOptions: getManageHrOptions(state),
  managePayCycleOptions: getManagePayCycleOptions(state),
  hasLoadedOptions: getHasLoadedOptions(state),
  payCycles: getPayCycleOptions(state),
});

const mapDispatchToProps = {
  saveStepWorkItOut: actionSaveStepWorkItOut,
};

// Can't use redux compose here as the types are not happy
export const WorkItOut = injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps,
)(WorkItOutController));
